import { render, staticRenderFns } from "./GoToButton.vue?vue&type=template&id=8dc9e4fe&scoped=true"
import script from "./GoToButton.vue?vue&type=script&lang=js"
export * from "./GoToButton.vue?vue&type=script&lang=js"
import style0 from "./GoToButton.vue?vue&type=style&index=0&id=8dc9e4fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc9e4fe",
  null
  
)

export default component.exports